import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET ALL LANGUAGE
export const getAllLanguage = createAsyncThunk('language/getAllLanguage', async (page = 1, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/languages?page=${page}&limit=10`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// GET LANGUAGE BY ID
export const getLanguageById = createAsyncThunk('language/getLanguageById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/languages/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// CREATE LANGUAGE
export const createLanguage = createAsyncThunk('language/createLanguage', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/languages`, { ...payload });

    thunkAPI.dispatch(getAllLanguage());

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// UPDATE LANGUAGE
export const updateLanguage = createAsyncThunk('language/updateLanguage', async (payload, thunkAPI) => {
  const { payloadData, languageId } = payload;

  try {
    const response = await axiosInstance.put(
      `/languages/${languageId}`,
      { ...payloadData },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    thunkAPI.dispatch(getAllLanguage());

    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// DELETE LANGUAGE
export const deleteLanguage = createAsyncThunk('language/deleteLanguage', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/languages/${id}`);

    thunkAPI.dispatch(getAllLanguage());

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
